$(document).ready(function () {

    $('.js-slideshow').each(function () {

        var slideshow = $(this);
        var slides = slideshow.find('.js-slide');
        var outer = slideshow.closest('.js-slideshow-outer');
        var pager = outer.find('.js-slideshow-thumbs');
        var next = outer.find('.js-next');
        var prev = outer.find('.js-prev');

        $(this).initCycle({
            'slides': slides,
            'pager': pager,
            'pagerTemplate': '<a href="#" class="full-width-slider__pager"></a>',
            'pageActiveClass': 'active',
            'next': next,
            'prev': prev
        });
    });

});